<!-- Button -->
<button
    [matMenuTriggerFor]="userActions">
    <lineuppro-user-avatar [photo]="user.avatar" [userName]="user.name" [displayUserName]="false"></lineuppro-user-avatar>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user?.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="updatePhoto()">
        <mat-icon [svgIcon]="'heroicons_outline:camera'"></mat-icon>
        <span>Update Photo</span>
    </button>
    <button mat-menu-item  (click)="settings()">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Settings</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

